module.exports = __webpack_public_path__ + "images/a2999c05.pay_2_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_2_cht.png
// module id = 542
// module chunks = 0